<!-- 移动端依赖 -->
<template>
    <div class="lianxin">
       <div class="banner w100">
            <img src="../../../../assets/images/special/lianxin/banner.png">
       </div>
        <div class="img1">
            <img src="../../../../assets/images/special/lianxin/img1.jpg" >
        </div>
        <div class="img2">
            <img src="../../../../assets/images/special/lianxin/img2.jpg">
        </div>
        <div class="img3">
            <img src="../../../../assets/images/special/lianxin/img3.jpg">
        </div>
    </div>
</template>
<script>

export default {
	components: {

	},
	data() {
		return {
			defined:{
			}
		}
	},
	mounted() {
	
	},
	methods: {
    }
}
</script>